import { isSSR } from "../utils/agent";

export default () => {
    if (!isSSR() && "serviceWorker" in navigator) {
        navigator.serviceWorker.register(`service-worker.${SW_VERSION}.js`).catch((error) => {
            console.error(error?.message ?? error);
        });
    }
};
